import React, { FC, memo, ReactNode } from 'react';
import { NameComponent } from 'reactApp/ui/Name/Name';

import styles from '../DataListItemRow.css';

interface DestinationProps {
    name: string;
    icon?: ReactNode;
}

export const Destination: FC<DestinationProps> = memo(function Destination({ name, icon }) {
    return (
        <div className={styles.destination}>
            {icon && <div className={styles.destinationIcon}>{icon}</div>}
            <NameComponent name={name} showTooltip />
        </div>
    );
});
